/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { eventsAPI } from '../services/api';
import OrphanLinkModal from '../components/OrphanLinkModal';

const card = { background:'#fff', border:'0.5px solid rgba(0,0,0,0.07)', borderRadius:'12px', boxShadow:'0 1px 3px rgba(0,0,0,0.05)' };

function Badge({ label, color, bg }) {
  return <span style={{ fontSize:'11px', fontWeight:500, padding:'2px 9px', borderRadius:'4px', color, background:bg }}>{label}</span>;
}

function timeAgo(d) {
  if (!d) return '—';
  const diff = Date.now() - new Date(d).getTime();
  const mins = Math.floor(diff/60000);
  if (mins < 1) return "à l'instant";
  if (mins < 60) return `il y a ${mins} min`;
  const hrs = Math.floor(mins/60);
  if (hrs < 24) return `il y a ${hrs}h`;
  const days = Math.floor(hrs/24);
  return `il y a ${days}j`;
}

function fmtDuration(s) {
  if (!s) return '—';
  return `${Math.floor(s/60)}m ${String(s%60).padStart(2,'0')}s`;
}

export default function Aircall() {
  const navigate = useNavigate();
  const [tab, setTab] = useState('linked');
  const [links, setLinks] = useState([]);
  const [orphans, setOrphans] = useState([]);
  const [counts, setCounts] = useState({});
  const [loading, setLoading] = useState(true);
  const [orphanModal, setOrphanModal] = useState(null);

  useEffect(() => { loadData(); }, [tab]);

  const loadData = async () => {
    setLoading(true);
    try {
      const [countRes] = await Promise.all([eventsAPI.orphansCount()]);
      setCounts(countRes.data || {});

      if (tab === 'linked') {
        const res = await eventsAPI.links({ source_type: 'aircall', limit: 50 });
        setLinks(res.data || []);
      } else if (tab === 'orphans') {
        const res = await eventsAPI.orphans({ source_type: 'aircall', status: 'pending', limit: 50 });
        setOrphans(res.data || []);
      }
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const orphanCount = counts.aircall || 0;

  const tabs = [
    { key:'linked',  label:'Appels liés' },
    { key:'orphans', label:'Appels non liés', badge: orphanCount },
    { key:'config',  label:'Configuration' },
  ];

  return (
    <div>
      {/* Header */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'1.5rem' }}>
        <div>
          <div style={{ fontFamily:'Syne, sans-serif', fontSize:'18px', fontWeight:600, color:'#1A1916' }}>Aircall</div>
          <div style={{ fontSize:'12px', color:'rgba(26,25,22,0.4)', marginTop:'2px' }}>Appels liés à vos dossiers</div>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display:'flex', gap:'6px', marginBottom:'1.25rem' }}>
        {tabs.map(t => (
          <button key={t.key} onClick={() => setTab(t.key)} style={{
            padding:'5px 14px', borderRadius:'999px', fontSize:'12px', cursor:'pointer',
            border:'0.5px solid rgba(0,0,0,0.1)', fontFamily:'DM Sans, sans-serif',
            background: tab === t.key ? '#1A1916' : 'transparent',
            color: tab === t.key ? '#fff' : 'rgba(26,25,22,0.5)',
            display:'flex', alignItems:'center', gap:'6px',
          }}>
            {t.label}
            {t.badge > 0 && (
              <span style={{
                background: tab === t.key ? 'rgba(255,255,255,0.2)' : '#B03020',
                color:'#fff',
                fontSize:'10px', fontWeight:600, padding:'1px 6px', borderRadius:'999px', minWidth:'16px', textAlign:'center',
              }}>{t.badge}</span>
            )}
          </button>
        ))}
      </div>

      {/* Tab: Linked */}
      {tab === 'linked' && (
        <div style={{ ...card, overflow:'hidden' }}>
          {loading ? (
            <div style={{ padding:'2rem', textAlign:'center', color:'rgba(26,25,22,0.35)', fontSize:'12px' }}>Chargement...</div>
          ) : links.length === 0 ? (
            <div style={{ padding:'2.5rem', textAlign:'center' }}>
              <div style={{ fontSize:'28px', marginBottom:'8px' }}>📭</div>
              <div style={{ fontSize:'13px', fontWeight:500, color:'#1A1916', marginBottom:'4px' }}>Aucun appel lié</div>
              <div style={{ fontSize:'12px', color:'rgba(26,25,22,0.4)' }}>Les appels Aircall correspondant à vos dossiers apparaîtront ici.</div>
            </div>
          ) : (
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead>
                <tr style={{ borderBottom:'0.5px solid rgba(0,0,0,0.07)' }}>
                  {['Direction','Numéro','Dossier','Durée','Date',''].map(h => (
                    <th key={h} style={{ textAlign:'left', padding:'10px 14px', fontSize:'10px', textTransform:'uppercase', letterSpacing:'0.07em', color:'rgba(26,25,22,0.28)', fontWeight:400 }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {links.map((l, i) => {
                  const meta = l.metadata_ || {};
                  return (
                    <tr key={l.id}
                      style={{ borderBottom: i < links.length-1 ? '0.5px solid rgba(0,0,0,0.05)' : 'none' }}
                      onMouseEnter={e => e.currentTarget.style.background='#F5F3EE'}
                      onMouseLeave={e => e.currentTarget.style.background='transparent'}
                    >
                      <td style={{ padding:'11px 14px', fontSize:'12px', color:'#1A1916' }}>
                        {meta.direction === 'outbound' ? '↗ Sortant' : '↙ Entrant'}
                      </td>
                      <td style={{ padding:'11px 14px', fontSize:'12px', color:'#1A1916', fontFamily:'monospace' }}>
                        {meta.number || l.source_id}
                      </td>
                      <td style={{ padding:'11px 14px' }}>
                        <span onClick={() => navigate('/dossiers')} style={{ fontSize:'12px', color:'#1A55A0', fontWeight:500, fontFamily:'monospace', cursor:'pointer' }}>
                          {meta.dossier_reference || l.dossier_id?.slice(0,8)}
                        </span>
                      </td>
                      <td style={{ padding:'11px 14px', fontSize:'12px', color:'rgba(26,25,22,0.55)' }}>
                        {fmtDuration(meta.duration)}
                      </td>
                      <td style={{ padding:'11px 14px', fontSize:'11px', color:'rgba(26,25,22,0.35)' }}>{timeAgo(l.linked_at)}</td>
                      <td style={{ padding:'11px 14px' }}>
                        <Badge label="Lié" color="#1A7A4A" bg="rgba(26,122,74,0.08)" />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* Tab: Orphans */}
      {tab === 'orphans' && (
        <div>
          {loading ? (
            <div style={{ ...card, padding:'2rem', textAlign:'center', color:'rgba(26,25,22,0.35)', fontSize:'12px' }}>Chargement...</div>
          ) : orphans.length === 0 ? (
            <div style={{ ...card, padding:'2.5rem', textAlign:'center' }}>
              <div style={{ fontSize:'28px', marginBottom:'8px' }}>✅</div>
              <div style={{ fontSize:'13px', fontWeight:500, color:'#1A1916', marginBottom:'4px' }}>Aucun appel en attente</div>
              <div style={{ fontSize:'12px', color:'rgba(26,25,22,0.4)' }}>Tous les appels Aircall sont liés à des dossiers.</div>
            </div>
          ) : (
            <div style={{ display:'flex', flexDirection:'column', gap:'8px' }}>
              {orphans.map(o => {
                const p = o.payload || {};
                return (
                  <div key={o.id} style={{ ...card, padding:'14px 18px', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                    <div style={{ flex:1 }}>
                      <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'4px' }}>
                        <span style={{ fontSize:'12px', fontWeight:600, color:'#1A1916' }}>
                          {p.direction === 'outbound' ? '↗ Sortant' : '↙ Entrant'}
                        </span>
                        <span style={{ fontSize:'12px', color:'#1A1916', fontFamily:'monospace' }}>{p.number || o.source_id}</span>
                        {p.duration && (
                          <span style={{ fontSize:'11px', color:'rgba(26,25,22,0.4)' }}>{fmtDuration(p.duration)}</span>
                        )}
                      </div>
                      <div style={{ fontSize:'11px', color:'rgba(26,25,22,0.35)' }}>
                        {p.contact_email || '—'} · {timeAgo(o.received_at)}
                      </div>
                    </div>
                    <div style={{ display:'flex', gap:'6px' }}>
                      <button onClick={() => setOrphanModal(o)} style={{
                        background:'#B8860B', color:'#fff', border:'none', borderRadius:'7px',
                        padding:'6px 14px', fontSize:'11px', fontWeight:500, cursor:'pointer', fontFamily:'DM Sans, sans-serif',
                      }}>Lier</button>
                      <button onClick={async () => {
                        try { await eventsAPI.ignoreOrphan(o.id); loadData(); } catch {}
                      }} style={{
                        background:'rgba(176,48,32,0.08)', color:'#B03020', border:'0.5px solid rgba(176,48,32,0.2)',
                        borderRadius:'7px', padding:'6px 12px', fontSize:'11px', cursor:'pointer', fontFamily:'DM Sans, sans-serif',
                      }}>Ignorer</button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/* Tab: Configuration */}
      {tab === 'config' && (
        <div style={{ ...card, padding:'1.25rem 1.5rem' }}>
          <div style={{ fontFamily:'Syne, sans-serif', fontSize:'13px', fontWeight:600, color:'#1A1916', marginBottom:'16px' }}>Configuration Aircall</div>
          <div style={{ fontSize:'12px', color:'rgba(26,25,22,0.55)', lineHeight:1.7, marginBottom:'20px' }}>
            La configuration Aircall est gérée par l'administrateur dans le panneau d'administration.<br/>
            Contactez votre administrateur pour modifier les paramètres de connexion ou le filtrage des appels.
          </div>
          <button onClick={() => navigate('/config')} style={{
            background:'transparent', border:'0.5px solid rgba(0,0,0,0.12)', borderRadius:'7px',
            padding:'7px 16px', fontSize:'12px', cursor:'pointer', color:'rgba(26,25,22,0.55)', fontFamily:'DM Sans, sans-serif',
          }}>
            Voir les connecteurs →
          </button>
        </div>
      )}

      {/* Orphan Link Modal */}
      {orphanModal && (
        <OrphanLinkModal
          orphan={orphanModal}
          onLinked={() => { setOrphanModal(null); loadData(); }}
          onIgnored={() => { setOrphanModal(null); loadData(); }}
          onClose={() => setOrphanModal(null)}
        />
      )}
    </div>
  );
}
